







































































































































































































































import { Component, Mixins } from 'vue-property-decorator'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import LabeledValue from '@/components/LabeledValue.vue'
import {
  Company,
  CompanyCollection,
  CompanyStatusEnum,
  CompanyTypeEnum,
  FavoriteList,
  FavoriteListCollection,
  IVendorPriceListEntry,
  Order,
  OrderCollection,
  OrderEntry, OrderStatusEnum, PriceList,
  PriceListCollection,
  ReminderCollection
} from 'serverless-firestore'
import LoadingPage from '@/components/LoadingPage.vue'
import axios from 'axios'
import OrderListItem from '@/components/Order/OrderListItem.vue'
import moment from 'moment'
import store, { Actions } from '../../../store'

interface IVendorOrderEntryMap {
  vendor: string,
  vendorCutoff: string,
  isVendorCutoffPastDue: boolean
  entries: OrderEntry[]
}

@Component({
  components: { OrderListItem, LoadingPage, LabeledValue }
})
export default class OrderDetail extends Mixins(IconsMixin, AuthMixin) {
  public wOrder: { data: Order | null } = { data: null }
  public vendors: Company[] = []
  public priceLists: PriceList[] = []
  public isActive: boolean = true
  public isDraft: boolean = false
  public isValid: boolean = false
  public errors: string[] = []

  public selectedEntryIndex: number = -1
  public reminders = new Map();
  // button loading actions
  public isApproving = false
  public isRejecting = false
  public isSubmittingToManager = false

  // modal props
  public showDeleteModal = false
  public showErrorModal = false
  public errorModalMessage = ''


  public get selectedEntry() {
    if (!this.order) {
      return null
    }

    return this.order.orderEntries[this.selectedEntryIndex]
  }

  public get vendorOrderMappedList() {
    if (!this.order) {
      return
    }

    const list: IVendorOrderEntryMap[] = []
    this.order.orderEntries.forEach((entry: OrderEntry) => {
      if (!entry.vendorCompanyId) {
        return
      }

      const vendor = this.lookupVendorName(entry.vendorCompanyId, entry.priceListId)
      let vendorEntry = list.find((listEntry: IVendorOrderEntryMap) => listEntry.vendor === vendor)
      if (!vendorEntry) {
        const vendorCutoff = this.lookupVendorCutoff(entry.vendorCompanyId)
        const isVendorCutoffPastDue = this.order && !this.order.isApproved && vendorCutoff !== 'Unknown'
            && moment(vendorCutoff, 'HH:mm').isBefore(moment()) || false

        vendorEntry = { vendor, vendorCutoff, isVendorCutoffPastDue, entries: [] }
        list.push(vendorEntry)
      }

      vendorEntry.entries.push(entry)
    })

    list.sort((a: IVendorOrderEntryMap, b: IVendorOrderEntryMap) => a.vendor.localeCompare(b.vendor))
    return list
  }

  public lookUpReminder(id:string){
    if (!this.order) {
      return null
    }
    let reminderReturn = this.reminders.get(id)
    if(!reminderReturn)
      reminderReturn = "None"
    return reminderReturn;
  }

  public async mounted() {
    try {
      this.isActive = this.userCompany.status === CompanyStatusEnum.ACTIVE

      const collection = new OrderCollection(( await this.$firebase ).firestore())
      this.wOrder = collection.watch(this.$route.params.id)

      const order = await collection.get(this.$route.params.id)
      if (!order || ( order.assignedCompanyId !== this.userCompany.id )) {
        const err = new Error('You do not have permissions to view that page')
        return store.dispatch(Actions.SET_ERROR, [err, this.$router])
      }
      this.isDraft = order.status === OrderStatusEnum.DRAFT
      if (this.isDraft) {
        this.isValid = this.isOrderValid(order)
      }

      const companyCollection = new CompanyCollection(( await this.$firebase ).firestore())
      this.vendors = companyCollection.watchCompaniesByType(CompanyTypeEnum.VENDOR)
      await this.setReminders(order);
      const priceListCollection = new PriceListCollection(( await this.$firebase ).firestore())
      this.priceLists = priceListCollection.watchPriceListsByCompanyId(this.userCompany.id, CompanyTypeEnum.RESTAURANT)
    } catch (error) {
      const err = new Error('You do not have permissions to view that page')
      return store.dispatch(Actions.SET_ERROR, [err, this.$router])
    }

  }

  private async setReminders(order: Order){
    const remindersCollection = new ReminderCollection(( await this.$firebase ).firestore());
    return Promise.all(order.orderEntries.map(async (entry: any) => {
      if (!this.userCompany.id || !entry.priceListEntryId || !entry.vendorCompanyId) {
        return
      }

      let reminder = await remindersCollection.listRemindersByRestaurantCompanyIdAndPriceListEntryIdAndVendorCompanyId(
        this.userCompany.id,
        entry.priceListEntryId,
        entry.vendorCompanyId
      )

      if (reminder) {
        this.reminders.set(entry.id, reminder.text);
      }
    }))
  }

  public lookupVendorName(vendorCompanyId: string, priceListId: string): string {
    const vendor = this.vendors.find((c: Company) => c.id === vendorCompanyId)
    return vendor ? vendor.displayName + this.lookupRepName(priceListId) : ''
  }

  public lookupRepName(priceListId: string) {
    const priceList = this.lookupPriceList(priceListId)

    if(priceList && priceList.vendorRepName) {
      return ` - ${priceList.vendorRepName}`
    } else {
      return ''
    }
  }

  public lookupPriceList(id: string): PriceList {
    const priceList = this.priceLists.find(
      priceList => priceList.id === id
    )

    return priceList ? priceList : {} as PriceList
  }

  public lookupVendorCutoff(vendorCompanyId: string): string {
    const priceList = this.priceLists.find((p: PriceList) => p.vendorCompanyId === vendorCompanyId)
    return priceList && priceList.cutoffTime ? moment(priceList.cutoffTime).format('HH:mm') : 'Unknown'
  }

  public async editOrder() {
    if (!this.order || !this.order.canEdit) {
      return
    }

    await this.$router.push({ name: 'order-edit', params: { id: this.order.id } })
  }

  public async approveOrder() {
    if (!this.order || !this.order.canApprove || (this.isDraft && !this.isValid)) {
      return false
    }

    this.isApproving = true
    this.order.approve(this.userClaim.user_id)
    await this.saveOrder()
    await this.addMissingEntriesToFavoriteList()
    await axios.post(`/api/order/${ this.order.id }/split`)
    this.isApproving = false
    return true
  }

  public async rejectOrder() {
    if (!this.order || !this.order.canApprove) {
      return false
    }

    this.isRejecting = true
    this.order.reject(this.userClaim.user_id)
    await this.saveOrder()
    this.isRejecting = false
    return true
  }

  public async submitOrder() {
    if (!this.order || !this.order.canEdit || (this.isDraft && !this.isValid)) {
      return false
    }

    this.isSubmittingToManager = true
    this.order.submitForApproval(this.userClaim.user_id)
    await this.saveOrder()
    this.isSubmittingToManager = false
    return true
  }

  public async submitAndApproveOrder() {
    try {
      (await this.submitOrder()) && (await this.approveOrder())
    } catch (err) {
      console.log(err)
    }
  }

  public confirmDelete() {
    this.showDeleteModal = false
    this.deleteOrder()
  }

  public isOrderValid(order: Order | null): order is Order {
    this.errors = []

    if(!(order instanceof Order)) {
      return false
    }

    if(!order.number) {
      this.errors.push("Please enter an order number")
    }
    if(!order.orderEntries || !order.orderEntries.length) {
      this.errors.push("You must enter at least one item")
      return false
    }
    if(!order.orderEntries.every(entry => entry.quantity > 0)) {
      this.errors.push("Quantity must be greater than zero on every item")
    }
    if(
      !order.orderEntries.every(entry => entry.vendorCompanyId && entry.priceListId)
    ) {
      this.errors.push("You must select a vendor for every item")
    }
    if(!order.orderEntries.every(entry => entry.description)) {
      this.errors.push("You must enter a description for every item")
    }
    if(
      !order.orderEntries.every(entry =>
        entry.quantityType !== 'See order comments'
        || entry.orderingNotes
      )
    ) {
      this.errors.push("You must enter Ordering Comments that describe the Quantity Type for every item that has a Quantity Type of 'See order comments'")
    }

    if(!order.orderEntries.every(entry => entry.category)) {
      this.errors.push("Please select a category for every entry")
    }

    return !this.errors.length
  }

  public async recreateOrder() {
    if(!this.order || !this.order.id) {
      return
    }
    await this.$router.push({ name: 'order-edit', params: { id: 'create' }, query: { reorder: this.order.id } })
  }

  public async deleteOrder() {
    if (!this.order || !this.order.canDelete) {
      return
    }

    try {
      const collection = new OrderCollection(( await this.$firebase ).firestore())
      await collection.delete(this.order)
      this.$router.replace({ name: 'order-list' })
    } catch (err) {
      this.errorModalMessage = err.message
      this.showErrorModal = true
    }
  }

  protected async saveOrder() {
    if (!this.order) {
      return
    }

    const collection = new OrderCollection(( await this.$firebase ).firestore())
    return collection.save(this.order)
  }

  protected async addMissingEntriesToFavoriteList() {
    if (!this.order) {
      return
    }

    const collection = new FavoriteListCollection(( await this.$firebase ).firestore())
    let originalFavoriteList = await collection.findFavoriteListByRestaurant(this.userCompany.id)

    if (!originalFavoriteList) {
      originalFavoriteList = new FavoriteList(this.userCompany.id)
    }

    const favoriteList = originalFavoriteList
    const originalFavoriteListEntriesLength = [...favoriteList.entries].length

    const operations = this.order.orderEntries.map(async orderEntry => {
      const entryFound = favoriteList.entries.find(e =>
        e.upc === orderEntry.upc && e.priceListId === orderEntry.priceListId
      )

      if (!entryFound) {
        const newEntry = {
          id: orderEntry.id,
          upc: orderEntry.upc,
          description: orderEntry.description,
          vendorCompanyId: orderEntry.vendorCompanyId,
          priceListId: orderEntry.priceListId,
          orderingNotes: orderEntry.orderingNotes,
          category: orderEntry.category,
          vendorCompanyName: await this.getVendorName(orderEntry)
        } as IVendorPriceListEntry

        favoriteList.entries.push(newEntry)
      }
    })

    await Promise.all(operations)

    if (favoriteList.entries.length > originalFavoriteListEntriesLength) {
      await collection.save(favoriteList)
    }
  }

  public async getVendorName(entry: OrderEntry) {
    if(!entry || !entry.vendorCompanyId) {
      return 'N/A'
    }

    const companyCollection = new CompanyCollection(( await this.$firebase ).firestore());
    const company = await companyCollection.getCompany(entry.vendorCompanyId)

    if (company) {
      return company.displayName
    }
  }

  get order(): Order | null {
    return this.wOrder.data
  }


}
